import React, { useEffect, useMemo } from 'react'
import { i18nInstance, TranslatedText } from '@staccx/i18n'
import DropDown from '../../../components/DropDownMenu'
import CustomSkeleton from './skeleton/skeleton'
import CarInfoShort from './CarInfoShort'
import styled, { css } from 'styled-components'

const mapDriver = (d) => ({ value: d?.id, label: d?.name })
const mapCar = (c) => ({
  value: c.accountNo,
  label: `${c.registrationNumber} - ${c.description} (${c.accountNo})`,
})

export default ({ roleType, drivers, driver, userCar, cars, car, driverHandler, carHandler }) => {
  const formattedDrivers = useMemo(() => {
    if (!drivers) {
      return null
    }
    const filteredDrivers = drivers?.filter((d) => d?.type !== 'Main Contact')
    return filteredDrivers.map(mapDriver)
  }, [drivers])

  const formattedCars = useMemo(() => {
    if (!cars) {
      return null
    }
    return cars.filter((car) => !!car.accountNo && !car.noCarReplacement).map(mapCar)
  }, [cars])

  const carToBeReplaced = useMemo(() => {
    if (!cars || car?.value === 'default') {
      driverHandler({ label: `-- ${i18nInstance.translate('NONE')} --`, value: 'default' })
      return null
    }

    if (userCar) {
      return userCar
    }

    if (car) {
      return cars.find((c) => c.accountNo === car.value)
    }
  }, [cars, car, userCar])

  useEffect(() => {
    if (carToBeReplaced?.driver?.id) {
      if (!driver && carToBeReplaced?.driver?.id !== driver?.value) {
        driverHandler(mapDriver(carToBeReplaced?.driver))
      }
    }
  }, [carToBeReplaced])

  useEffect(() => {
    if (car && !car?.value) {
      carHandler(mapCar(car))
    }
    if (driver && !driver?.value) {
      driverHandler((prevState) => mapDriver(prevState))
    }
  }, [car, driver])

  return (
    <ExtrasContainer>
      {roleType === 2 && (
        <div>
          <TranslatedText i18nKey="CONFIGURATION_REPLACES_VEHICLE">{(value) => <Span>{value}</Span>}</TranslatedText>
          {formattedCars ? (
            <DropDown
              width={'100%'}
              resetObject={{ label: `-- ${i18nInstance.translate('NONE')} --`, value: 'default' }}
              options={formattedCars}
              value={car}
              placeholder={`-- ${i18nInstance.translate('NONE')} --`}
              onChange={(d) => carHandler(d)}
            />
          ) : (
            <CustomSkeleton
              skeletons={[
                {
                  height: 30,
                  count: 1,
                },
              ]}
              theme={css`
                background-color: var(--color-bg);
                grid-template-columns: 1fr;
              `}
            />
          )}
        </div>
      )}
      <div>
        {roleType === 1 && (
          <TranslatedText i18nKey="CONFIGURATION_REPLACES_VEHICLE">{(value) => <Span>{value}</Span>}</TranslatedText>
        )}
        {carToBeReplaced && <CarInfoShort car={carToBeReplaced} />}
      </div>

      {roleType === 2 && (
        <div>
          <TranslatedText i18nKey="DRIVER">{(value) => <Span>{value}</Span>}</TranslatedText>
          {formattedDrivers ? (
            <DropDown
              width={'100%'}
              resetObject={{ label: `-- ${i18nInstance.translate('NONE')} --`, value: 'default' }}
              options={formattedDrivers}
              value={driver}
              placeholder={`-- ${i18nInstance.translate('NONE')} --`}
              onChange={(d) => driverHandler(d)}
              overlap={true}
            />
          ) : (
            <CustomSkeleton
              skeletons={[
                {
                  height: 30,
                  count: 1,
                },
              ]}
              theme={css`
                background-color: var(--color-bg);
                display: grid;
                grid-template-columns: 1fr;
              `}
            />
          )}
        </div>
      )}
    </ExtrasContainer>
  )
}

const ExtrasContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-medium);
`

const Span = styled.span`
  font-size: var(--font-h3);
  font-weight: var(--fontWeight-bold);
  line-height: 1.5em;
`
